export const PURCHASE_BY_PROVISION='PURCHASE_BY_PROVISION'
export const PURCHASE_BY_PROVISION_SUCCESS='PURCHASE_BY_PROVISION_SUCCESS'
export const PURCHASE_BY_PROVISION_ERROR='PURCHASE_BY_PROVISION_ERROR'

export const PurchaseByProvision = (data) => ({
    type: PURCHASE_BY_PROVISION,
    payload: data
})